import BaseCellRenderer, { IBaseCellRendererParams } from "./BaseCellRenderer";
import { useEffect, useState } from "react";

export default function PriceCellRenderer(props: IBaseCellRendererParams<number>) {
    const price: number | null | undefined = props.valueFormatted != null ? (props.valueFormatted === "" ? null : Number.parseFloat(props.valueFormatted)) : typeof props.value === "object" ? props.value?.value : props.value;   
    return (
        <BaseCellRenderer {...props}>
            {price != null && !Number.isNaN(price) ? (price >= 0 ? <>${price.formatAsPrice(true)}</> : <>-${(price*-1).formatAsPrice(true)}</>) : <></>}
        </BaseCellRenderer>
    );
}